import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import {
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getRightPackageUom,
  getRightSaluation,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  reorderList,
  roundWithSignedDiff,
} from "../../../util/function";

const BillingPreview = ({
  modVsble = false,
  selectedBill = null,
  onClosePreview = () => {},
  billsToShow = [],
}) => {
  const [isDotMatrixPrint, setDotMatrixPrint] = useState(false);
  const contentToPrint = useRef(null);
  const { details: clinicDet } = useSelector((state) => state?.clinic);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const isBillCombined =
    (clinicDet?.billingMode ?? "")?.toLowerCase() === "combined";
  const dotMatrixPageStyle = `
    @page {
      size: 254mm 558.8mm;
      margin: 0pt;
    }

    @media print {
      .billing-print-root.billing-dotmatrix {
        width: 254mm !important;
        max-width: 254mm !important;
        margin: 0 !important;
        font-size: 12pt !important;
        line-height: 1.2 !important;
        page-break-after: auto;
      }

      .billing-print-root.billing-dotmatrix::after {
        content: "\\A\\A\\A\\A\\A\\A\\A\\A\\A\\A\\A\\A\\A\\A\\A";
        white-space: pre;
      }
    }
  `;

  const handlePrint = useReactToPrint({
    documentTitle: `${clinicDet?.name ?? ""}-${
      selectedBill?.invoiceNumbers ?? ""
    }`,
    removeAfterPrint: true,
    pageStyle: isDotMatrixPrint ? dotMatrixPageStyle : "",
  });

  return (
    <CustomModal
      open={modVsble}
      onClose={onClosePreview}
      header=""
      modal
      modalWidth={90}
    >
      <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
        <div
          ref={contentToPrint}
          className={`billing-print-root ${
            isDotMatrixPrint ? "billing-dotmatrix" : ""
          }`}
        >
          {billsToShow?.includes("treatment") &&
          getTreatmentRecordBasedType(selectedBill?.paymentDetails)?.length >
            0 ? (
            <>
              {selectedBill?.type !== "Pharmacy" &&
              selectedBill?.type !== "Pet Shop" ? (
                <div className="mt30">
                  <div className="flex-row-ali-cen mv20">
                    <div className="w30Per">
                      {isDotMatrixPrint ? null : (
                        <div className="pl20">
                          <div>
                            {clinicDet?.image ? (
                              <img
                                src={clinicDet?.image}
                                className="img-h75"
                                alt=""
                              />
                            ) : (
                              <div className="flex-center h50img">
                                <Typography className="font-bold fs30 white-color capitalize">
                                  {clinicDet?.name?.[0]}
                                </Typography>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="w40Per flex-center">
                      <div className="font-bold fs18 blue-color">
                        {isBillCombined
                          ? "TAX INVOICE"
                          : (selectedBill?.type === "Clinic" &&
                                !selectedBill?.appointmentId) ||
                              ((selectedBill?.type === "Pharmacy" ||
                                selectedBill?.type === "Pet Shop") &&
                                selectedBill?.checkOut !== "P" &&
                                selectedBill?.checkOut !== "Y")
                            ? "BILL ESTIMATE"
                            : "TREATMENT INVOICE"}
                        {/* {selectedBill?.type === "Pharmacy" ||
                        selectedBill?.type === "Pet Shop"
                          ? selectedBill?.checkOut === "P" ||
                            selectedBill?.checkOut === "Y"
                            ? "TREATMENT INVOICE"
                            : "BILL ESTIMATE"
                          : "TREATMENT INVOICE"} */}
                      </div>
                    </div>
                    <div className="w30Per flex1-end">
                      <div className="flex-column">
                        {/* <div className="font-bold fs12 blue-color">
                          Business Name:
                        </div> */}
                        <div className="font-bold blue-color fs16">
                          {clinicDet?.name ?? profile?.name ?? ""}
                        </div>
                        {/* <div className="font-bold fs12 blue-color">
                          Business Address:
                        </div> */}
                        <div className="header-right-text2">
                          {clinicDet?.address ?? ""}
                        </div>
                        {clinicDet?.taxId?.length > 0 ? (
                          <div className="flex-row-ali-cen">
                            <div className="font-bold fs12 blue-color">
                              {/* CLINIC  */}
                              TAX ID:{" "}
                            </div>
                            <div className="header-right-text2 ml3">
                              {clinicDet?.taxId ?? ""}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {clinicDet?.mobile?.length > 0 ? (
                          <div className="flex-row-ali-cen">
                            <div className="font-bold fs12 blue-color">
                              Contact:{" "}
                            </div>
                            <div className="header-right-text2 ml3">
                              {clinicDet?.mobile ?? ""}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="line" />
                  <div className="flex-row mt10 ph30">
                    <div className="w60Per">
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Parent Name
                        </Typography>
                        <div className="txt-semi-bold fs14 black capitalize ml10">
                          {selectedBill?.userName}
                        </div>
                      </div>
                      {selectedBill?.mobile?.length > 0 ? (
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 gray4">
                            Phone Number
                          </Typography>
                          <div className="txt-semi-bold fs14 black capitalize ml10">
                            {selectedBill?.mobile}
                          </div>
                        </div>
                      ) : null}
                      {selectedBill?.apartmentAddress?.length > 0 ? (
                        <div className="flex-row">
                          <Typography className="font-bold fs14 gray4">
                            Address
                          </Typography>

                          <div className="txt-semi-bold fs14 black capitalize ml10 w50Per flex-row-wrap">
                            {selectedBill?.apartmentAddress}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    {selectedBill?.checkOut === "Y" ||
                    selectedBill?.checkOut === "P" ? (
                      <div className="flex1-end w40Per">
                        <div className="flex-column">
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Payment Status
                            </Typography>
                            <Typography
                              className={`ml10 fs16 font-bold capitalize ${
                                selectedBill?.status === "paid"
                                  ? "green2"
                                  : selectedBill?.status === "unpaid"
                                    ? "red2"
                                    : "orange-color"
                              }`}
                            >
                              {selectedBill?.status === "partiallypaid"
                                ? "Partially Paid"
                                : selectedBill?.status}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Total
                            </Typography>
                            <Typography className="black fs16 font-bold ml10">
                              Rs{" "}
                              {Number(
                                roundWithSignedDiff(
                                  getTaxAndSubTotalAndTotal(
                                    getTreatmentRecordBasedType(
                                      selectedBill?.paymentDetails,
                                    ),
                                  )?.subTotal,
                                )?.rounded,
                              )?.toFixed(2)}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Amount Paid
                            </Typography>
                            <Typography className="green-color fs16 font-bold ml10">
                              Rs{" "}
                              {Number(selectedBill?.amtPaid) > 0
                                ? Number(selectedBill?.amtPaid)?.toFixed(2)
                                : Number(selectedBill?.amtPaid)}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <Typography className="font-bold fs14 gray4">
                              Balance Due
                            </Typography>
                            <Typography className="yellow-color fs16 font-bold ml10">
                              Rs{" "}
                              {Number(
                                Number(
                                  roundWithSignedDiff(
                                    getTaxAndSubTotalAndTotal(
                                      getTreatmentRecordBasedType(
                                        selectedBill?.paymentDetails,
                                      ),
                                    )?.subTotal,
                                  )?.rounded,
                                ) - Number(selectedBill?.amtPaid ?? 0),
                              )?.toFixed(2)}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="lower-container">
                    <div className="box-container">
                      <div className="row-container">
                        <div>
                          <div className="colum-header">Pet Name</div>
                          <div className="colum-data">
                            {selectedBill?.petName}
                          </div>
                        </div>
                        <div>
                          <div className="colum-header">Vet Name</div>
                          <div className="colum-data capitalize">
                            {getRightSaluation(
                              clinicVets,
                              selectedBill?.doctorId,
                            )}
                            {selectedBill?.doctorName}
                          </div>
                        </div>
                        <div>
                          <div className="colum-header">Invoice Number</div>
                          <div className="colum-data">
                            {selectedBill?.treatmentInvoiceNumber ?? ""}
                          </div>
                        </div>
                        <div>
                          <div className="colum-header">Invoice Date</div>
                          <div className="colum-data">
                            {moment(new Date(selectedBill?.createdDate)).format(
                              "DD MMM YYYY",
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="thin-line"></div>

                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th className="w10Per">HSN/SAC Code</th>
                            <th className="w20Per">SERVICE / ITEM NAME</th>
                            <th className="w10Per">BATCH NO.</th>
                            <th className="w10Per">EXPIRY</th>
                            <th className="w10Per">QTY</th>
                            <th className="w10Per">UNIT PRICE</th>
                            {getTreatmentRecordBasedType(
                              selectedBill?.paymentDetails,
                            )?.some((li) => li?.discount > 0) ? (
                              <th className="w10Per">UNIT DISCOUNT (Rs)</th>
                            ) : null}
                            <th className="w10Per">TAX</th>
                            <th className="w10Per">TOTAL</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getTreatmentRecordBasedType(
                            selectedBill?.paymentDetails,
                          )?.length > 0 &&
                            getTreatmentRecordBasedType(
                              selectedBill?.paymentDetails,
                            )
                              ?.filter((pd) => pd?.type === "consultation")
                              ?.map((con) => (
                                <tr>
                                  <td>-</td>
                                  <td>
                                    <div className="flex-row-ali-cen">
                                      Consultation (
                                      {con?.name === "Home"
                                        ? "Home Visit"
                                        : con?.name}
                                      ){" "}
                                      {selectedBill?.doctorName?.length > 0
                                        ? " - "
                                        : ""}
                                      <div className="font-bold fs12 black ml3">
                                        {selectedBill?.doctorName?.length > 0
                                          ? `${getRightSaluation(
                                              clinicVets,
                                              selectedBill?.doctorId,
                                            )}${selectedBill?.doctorName}`
                                          : ""}
                                      </div>
                                      {selectedBill?.registrationNo?.length >
                                      0 ? (
                                        <div className="flex-row-ali-cen">
                                          <div className="font-regular fs12 black ml5">
                                            (
                                          </div>
                                          <div className="font-bold fs12 black ml2">
                                            RegNo:
                                          </div>
                                          <div className="font-regular fs12 black ml5 capitalize">
                                            {selectedBill?.registrationNo ??
                                              selectedBill?.registrationNo}{" "}
                                            )
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>1</td>
                                  <td>Rs {Number(con?.price)?.toFixed(2)}</td>
                                  {getTreatmentRecordBasedType(
                                    selectedBill?.paymentDetails,
                                  )?.some((li) => li?.discount > 0) ? (
                                    <td>
                                      {con?.discount > 0
                                        ? Number(con?.discount)?.toFixed(2)
                                        : "-"}
                                    </td>
                                  ) : null}
                                  <td>
                                    {con?.tax > 0
                                      ? `Rs ${Number(con?.tax)?.toFixed(2)}`
                                      : "-"}
                                  </td>
                                  <td>Rs {Number(con?.total)?.toFixed(2)}</td>
                                </tr>
                              ))}

                          {getTreatmentRecordBasedType(
                            selectedBill?.paymentDetails,
                          )?.length > 0 &&
                            reorderList(
                              getTreatmentRecordBasedType(
                                selectedBill?.paymentDetails,
                              ),
                            )
                              ?.filter((pd) =>
                                pd?.type !== "consultation" &&
                                pd?.type?.toLowerCase() !== "consumables" &&
                                selectedBill?.showSublineItems
                                  ? true
                                  : pd?.patientWorkbook
                                    ? pd?.mainProcedure
                                    : true,
                              )
                              ?.map((itm, i) => {
                                const isSubItem =
                                  (itm?.procedureId ?? "")?.toString()?.length >
                                    0 &&
                                  // itm?.patientWorkbook &&
                                  !itm?.mainProcedure &&
                                  itm?.linked !== "N";
                                const showSubPrice =
                                  selectedBill?.showSublinePrice;
                                const reqTotal = showSubPrice
                                  ? (itm?.total ?? 0)
                                  : itm?.list?.length > 0
                                    ? Number(
                                        Number(
                                          itm?.list
                                            ?.filter((li) =>
                                              selectedBill?.showSublinePrice
                                                ? li?.type?.toLowerCase() !==
                                                  "consumables"
                                                : true,
                                            )
                                            ?.reduce(
                                              (acc, li) =>
                                                acc + Number(li?.total),
                                              0,
                                            ) ?? 0,
                                        ) + Number(itm?.total ?? 0),
                                      )
                                    : (itm?.total ?? 0);
                                const reqUnitPrice = showSubPrice
                                  ? (itm?.mrpPrice ?? itm?.price ?? 0)
                                  : itm?.list?.length > 0
                                    ? Number(
                                        Number(
                                          itm?.list
                                            ?.filter((li) =>
                                              selectedBill?.showSublinePrice
                                                ? li?.type?.toLowerCase() !==
                                                  "consumables"
                                                : true,
                                            )
                                            ?.reduce(
                                              (acc, li) =>
                                                acc +
                                                Number(
                                                  li?.mrpPrice ?? li?.price,
                                                ),
                                              0,
                                            ) ?? 0,
                                        ) +
                                          Number(
                                            itm?.mrpPrice ?? itm?.price ?? 0,
                                          ),
                                      )
                                    : (itm?.mrpPrice ?? itm?.price ?? 0);

                                const reqDiscount = showSubPrice
                                  ? (itm?.discount ?? 0)
                                  : itm?.list?.length > 0
                                    ? Number(
                                        Number(
                                          itm?.list
                                            ?.filter((li) =>
                                              selectedBill?.showSublinePrice
                                                ? li?.type?.toLowerCase() !==
                                                  "consumables"
                                                : true,
                                            )
                                            ?.reduce(
                                              (acc, li) =>
                                                acc + Number(li?.discount),
                                              0,
                                            ) ?? 0,
                                        ) + Number(itm?.discount ?? 0),
                                      )
                                    : (itm?.discount ?? 0);
                                if (
                                  isSubItem &&
                                  !selectedBill?.showSublineItems
                                ) {
                                  return null;
                                }

                                return (
                                  <>
                                    <tr key={`${itm?.paymentDetailId}_${i}`}>
                                      <td>
                                        <div
                                          className={
                                            isSubItem
                                              ? ""
                                              : "fs12 font-bold black"
                                          }
                                        >
                                          {itm?.hsnSacCode?.length > 0
                                            ? itm?.hsnSacCode
                                            : "-"}
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          className={
                                            isSubItem
                                              ? ""
                                              : "fs12 font-bold black"
                                          }
                                        >
                                          {itm?.name}
                                          {itm?.stockId ? (
                                            <div>
                                              <div className="font-medium fs10 gray4">
                                                Trade Name:{" "}
                                                {itm?.tradeName ?? ""}
                                              </div>
                                              {itm?.drugSchedule?.length > 0 ? (
                                                <div className="fs10 gray4 font-medium">
                                                  Drug Schedule:{" "}
                                                  {itm?.drugSchedule ?? ""}
                                                </div>
                                              ) : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          className={
                                            isSubItem
                                              ? ""
                                              : "fs12 font-bold black"
                                          }
                                        >
                                          {itm?.stockId &&
                                          !itm?.autoConsumed &&
                                          itm?.batchNo?.length > 0
                                            ? itm?.batchNo
                                            : "-"}
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          className={
                                            isSubItem
                                              ? ""
                                              : "fs12 font-bold black"
                                          }
                                        >
                                          {itm?.stockId &&
                                          !itm?.autoConsumed &&
                                          itm?.expiryDate?.length > 0
                                            ? moment(
                                                new Date(itm?.expiryDate),
                                              ).format("DD MMM YYYY")
                                            : "-"}
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          className={
                                            isSubItem
                                              ? ""
                                              : "fs12 font-bold black"
                                          }
                                        >
                                          {itm?.quantity}
                                          {itm?.stockId &&
                                          itm?.packageUom?.length > 0
                                            ? `${getRightPackageUom(
                                                itm?.packageUom,
                                                true,
                                              )}`
                                            : ""}
                                        </div>
                                      </td>
                                      <td>
                                        {isSubItem && !showSubPrice ? null : (
                                          <div
                                            className={
                                              isSubItem
                                                ? ""
                                                : "fs12 font-bold black"
                                            }
                                          >
                                            Rs{" "}
                                            {Number(
                                              !showSubPrice
                                                ? reqTotal
                                                : reqUnitPrice,
                                            )?.toFixed(2)}
                                          </div>
                                        )}
                                      </td>
                                      {getTreatmentRecordBasedType(
                                        selectedBill?.paymentDetails,
                                      )?.some((li) => li?.discount > 0) ? (
                                        <td>
                                          {isSubItem && !showSubPrice ? null : (
                                            <div
                                              className={
                                                isSubItem
                                                  ? ""
                                                  : "fs12 font-bold black"
                                              }
                                            >
                                              {Number(reqDiscount) > 0
                                                ? Number(reqDiscount)?.toFixed(
                                                    2,
                                                  )
                                                : "-"}
                                            </div>
                                          )}
                                        </td>
                                      ) : null}
                                      <td>
                                        {isSubItem && !showSubPrice ? null : (
                                          <div
                                            className={
                                              isSubItem
                                                ? ""
                                                : "fs12 font-bold black"
                                            }
                                          >
                                            {itm?.tax > 0
                                              ? `Rs ${Number(itm?.tax)?.toFixed(
                                                  2,
                                                )}`
                                              : "-"}
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        {isSubItem && !showSubPrice ? null : (
                                          <div
                                            className={
                                              isSubItem
                                                ? ""
                                                : "fs12 font-bold black"
                                            }
                                          >
                                            Rs {Number(reqTotal)?.toFixed(2)}
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                          {selectedBill?.showSublineItems &&
                            reorderList(
                              getTreatmentRecordBasedType(
                                selectedBill?.paymentDetails,
                              ),
                            )?.filter(
                              (pd) => pd?.type?.toLowerCase() === "consumables",
                            )?.length > 0 &&
                            reorderList(
                              getTreatmentRecordBasedType(
                                selectedBill?.paymentDetails,
                              ),
                            )
                              ?.filter(
                                (pd) =>
                                  pd?.type?.toLowerCase() === "consumables",
                              )
                              ?.slice(0, 1)
                              ?.map((itm, i) => {
                                const reqTotal =
                                  reorderList(
                                    getTreatmentRecordBasedType(
                                      selectedBill?.paymentDetails,
                                    ),
                                  )
                                    ?.filter(
                                      (pd) =>
                                        pd?.type?.toLowerCase() ===
                                        "consumables",
                                    )
                                    ?.reduce(
                                      (acc, li) => acc + Number(li?.total),
                                      0,
                                    ) ?? 0;

                                const reqUnitPrice =
                                  reorderList(
                                    getTreatmentRecordBasedType(
                                      selectedBill?.paymentDetails,
                                    ),
                                  )
                                    ?.filter(
                                      (pd) =>
                                        pd?.type?.toLowerCase() ===
                                        "consumables",
                                    )
                                    ?.reduce(
                                      (acc, li) =>
                                        acc +
                                        Number(
                                          Number(
                                            li?.mrpPrice ?? li?.price ?? 0,
                                          ) * Number(li?.quantity ?? 1),
                                        ),
                                      0,
                                    ) ?? 0;

                                const reqDiscount =
                                  reorderList(
                                    getTreatmentRecordBasedType(
                                      selectedBill?.paymentDetails,
                                    ),
                                  )
                                    ?.filter(
                                      (pd) =>
                                        pd?.type?.toLowerCase() ===
                                        "consumables",
                                    )
                                    ?.reduce(
                                      (acc, li) => acc + Number(li?.discount),
                                      0,
                                    ) ?? 0;

                                return (
                                  <>
                                    <tr key={i}>
                                      <td>
                                        <div className="fs12 font-bold black">
                                          -
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fs12 font-bold black">
                                          Medical Consumables
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fs12 font-bold black">
                                          -
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fs12 font-bold black">
                                          -
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fs12 font-bold black">
                                          1
                                        </div>
                                      </td>
                                      <td>
                                        {selectedBill?.showSublinePrice ? (
                                          <div className="fs12 font-bold black">
                                            Rs{" "}
                                            {Number(reqUnitPrice)?.toFixed(2)}
                                          </div>
                                        ) : null}
                                      </td>
                                      {getTreatmentRecordBasedType(
                                        selectedBill?.paymentDetails,
                                      )?.some(
                                        (li) =>
                                          li?.discount > 0 &&
                                          selectedBill?.showSublinePrice,
                                      ) ? (
                                        <td>
                                          <div className="fs12 font-bold black">
                                            {Number(reqDiscount) > 0
                                              ? Number(reqDiscount)?.toFixed(2)
                                              : "-"}
                                          </div>
                                        </td>
                                      ) : null}
                                      <td>
                                        {selectedBill?.showSublinePrice ? (
                                          <div className="fs12 font-bold black">
                                            {Number(
                                              getTaxAndSubTotalAndTotal(
                                                getTreatmentRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                )?.filter(
                                                  (pd) =>
                                                    pd?.type?.toLowerCase() ===
                                                    "consumables",
                                                ),
                                              )?.tax ?? 0,
                                            ) > 0
                                              ? Number(
                                                  getTaxAndSubTotalAndTotal(
                                                    getTreatmentRecordBasedType(
                                                      selectedBill?.paymentDetails,
                                                    )?.filter(
                                                      (pd) =>
                                                        pd?.type?.toLowerCase() ===
                                                        "consumables",
                                                    ),
                                                  )?.tax,
                                                )?.toFixed(2)
                                              : "-"}
                                          </div>
                                        ) : null}
                                      </td>
                                      <td>
                                        {selectedBill?.showSublinePrice ? (
                                          <div className="fs12 font-bold black">
                                            Rs {Number(reqTotal)?.toFixed(2)}
                                          </div>
                                        ) : null}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}

                          <tr>
                            <td colSpan="12">
                              <hr className="thin-line2" />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="12">
                              <div className="flex-row-between">
                                <div className="w55Per ali-itm-flx-end">
                                  <div className="flex-column w100Per">
                                    <div className="flex-row-ali-cen mb5">
                                      <div className="txt-semi-bold fs12 black">
                                        Billed by:
                                      </div>
                                      <Typography className="font-bold fs12 gray4 ml10">
                                        {selectedBill?.billedByName ?? ""}
                                      </Typography>
                                    </div>
                                    {clinicDet?.disclaimer?.length > 0 ? (
                                      <div className="flex-row-ali-cen mb5">
                                        <div className="txt-semi-bold fs12 black">
                                          Disclaimer:
                                        </div>
                                        <Typography className="fs12 txt-regular gray-color ml10">
                                          {clinicDet?.disclaimer}
                                        </Typography>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="w45Per flex-end pr10">
                                  <div className="flex-column w100Per">
                                    <div className="flex-row-ali-cen mv5">
                                      <div className="w60Per">
                                        <div className="txtstyle">
                                          Treatment Subtotal
                                        </div>
                                      </div>
                                      <div className="w40Per flex-end">
                                        <div className="txtstyle">
                                          Rs{" "}
                                          {Number(
                                            getTaxAndSubTotalAndTotal(
                                              getTreatmentRecordBasedType(
                                                selectedBill?.paymentDetails,
                                              ),
                                            )?.total ?? 0,
                                          )?.toFixed(2)}
                                        </div>
                                      </div>
                                    </div>
                                    {Number(
                                      getTaxAndSubTotalAndTotal(
                                        getTreatmentRecordBasedType(
                                          selectedBill?.paymentDetails,
                                        ),
                                      )?.discount,
                                    ) > 0 ? (
                                      <div className="flex-row-ali-cen mb5">
                                        <div className="w70Per">
                                          <div className="txtstyle">
                                            Discount
                                          </div>
                                        </div>
                                        <div className="w30Per flex-end">
                                          <div className="txtstyle">
                                            {Number(
                                              getTaxAndSubTotalAndTotal(
                                                getTreatmentRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.discount,
                                            ) > 0
                                              ? `Rs ${Number(
                                                  getTaxAndSubTotalAndTotal(
                                                    getTreatmentRecordBasedType(
                                                      selectedBill?.paymentDetails,
                                                    ),
                                                  )?.discount,
                                                ).toFixed(2)}`
                                              : "-"}
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    <div className="flex-row-ali-cen mv5">
                                      <div className="w60Per">
                                        <div className="txtstyle">
                                          Taxes (CGST)
                                        </div>
                                      </div>
                                      <div className="w40Per flex-end">
                                        <div className="txtstyle">
                                          {Number(
                                            getTaxAndSubTotalAndTotal(
                                              getTreatmentRecordBasedType(
                                                selectedBill?.paymentDetails,
                                              ),
                                            )?.tax ?? 0,
                                          ) /
                                            2 >
                                          0
                                            ? `Rs ${Number(
                                                Number(
                                                  getTaxAndSubTotalAndTotal(
                                                    getTreatmentRecordBasedType(
                                                      selectedBill?.paymentDetails,
                                                    ),
                                                  )?.tax ?? 0,
                                                ) / 2,
                                              )?.toFixed(2)}`
                                            : "-"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex-row-ali-cen mv5">
                                      <div className="w60Per">
                                        <div className="txtstyle">
                                          Taxes (SGST)
                                        </div>
                                      </div>
                                      <div className="w40Per flex-end">
                                        <div className="txtstyle">
                                          {Number(
                                            getTaxAndSubTotalAndTotal(
                                              getTreatmentRecordBasedType(
                                                selectedBill?.paymentDetails,
                                              ),
                                            )?.tax ?? 0,
                                          ) /
                                            2 >
                                          0
                                            ? `Rs ${Number(
                                                Number(
                                                  getTaxAndSubTotalAndTotal(
                                                    getTreatmentRecordBasedType(
                                                      selectedBill?.paymentDetails,
                                                    ),
                                                  )?.tax ?? 0,
                                                ) / 2,
                                              )?.toFixed(2)}`
                                            : "-"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex-row-ali-cen mv5">
                                      <div className="w60Per">
                                        <div className="txtstyle">
                                          Round Off
                                        </div>
                                      </div>
                                      <div className="w40Per flex-end">
                                        <div className="txtstyle">
                                          {`Rs ${Number(
                                            Number(
                                              roundWithSignedDiff(
                                                getTaxAndSubTotalAndTotal(
                                                  getTreatmentRecordBasedType(
                                                    selectedBill?.paymentDetails,
                                                  ),
                                                )?.subTotal,
                                              )?.difference,
                                            ),
                                          )?.toFixed(2)}`}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="balancecontainer ph5 mt10">
                                      <div className="flex-row-ali-cen w100Per">
                                        <div className="w60Per">
                                          <div className="txt-semi-bold fs14 blue-color">
                                            Total
                                          </div>
                                        </div>
                                        <div className="w40Per flex-end">
                                          <div className="txt-semi-bold fs14 blue-color">
                                            Rs{" "}
                                            {Number(
                                              roundWithSignedDiff(
                                                getTaxAndSubTotalAndTotal(
                                                  getTreatmentRecordBasedType(
                                                    selectedBill?.paymentDetails,
                                                  ),
                                                )?.subTotal,
                                              )?.rounded,
                                            )?.toFixed(2)}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <div className="mb20" />
                        </tbody>
                      </table>
                      {isDotMatrixPrint ? null : (
                        <div className="flex-row mv20 ph10">
                          <img
                            src={require("../../../assets/images/jpg/WoofQrCode.jpeg")}
                            alt=""
                            className="img-h50"
                          />
                          <div className="blu-back wh50 flex-center">
                            <img
                              src={require("../../../assets/images/png/VetInstantLogo.png")}
                              alt=""
                              className="img-h40"
                            />
                          </div>
                          <div className="flex-center">
                            <div className="font-bold fs14 ml20">
                              Scan to download our app
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="page-break" />
            </>
          ) : null}
          {billsToShow?.includes("pharmacy") &&
          getPharmacyRecordBasedType(selectedBill?.paymentDetails)?.length >
            0 ? (
            <div className="mt30">
              <div className="flex-row-ali-cen mv20">
                <div className="w30Per">
                  {isDotMatrixPrint ? null : (
                    <div className="pl20">
                      <div>
                        {clinicDet?.image ? (
                          <img
                            src={clinicDet?.image}
                            className="img-h75"
                            alt=""
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {clinicDet?.name?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="w40Per flex-center">
                  <div className="font-bold fs18 blue-color">
                    {isBillCombined
                      ? "TAX INVOICE"
                      : (selectedBill?.type === "Clinic" &&
                            !selectedBill?.appointmentId) ||
                          ((selectedBill?.type === "Pharmacy" ||
                            selectedBill?.type === "Pet Shop") &&
                            selectedBill?.checkOut !== "P" &&
                            selectedBill?.checkOut !== "Y" &&
                            selectedBill?.pharmacyCheckout !== "Y")
                        ? "BILL ESTIMATE"
                        : `${
                            selectedBill?.type === "Pharmacy" ||
                            selectedBill?.type === "Pet Shop"
                              ? "TAX"
                              : "PHARMACY"
                          } INVOICE`}
                    {/* {selectedBill?.type === "Pharmacy" ||
                    selectedBill?.type === "Pet Shop"
                      ? selectedBill?.checkOut === "P" ||
                        selectedBill?.checkOut === "Y" ||
                        selectedBill?.pharmacyCheckout === "Y"
                        ? `${
                            selectedBill?.type === "Pharmacy" ||
                            selectedBill?.type === "Pet Shop"
                              ? "TAX"
                              : "PHARMACY"
                          } INVOICE`
                        : "BILL ESTIMATE"
                      : `${
                          selectedBill?.type === "Pharmacy" ||
                          selectedBill?.type === "Pet Shop"
                            ? "TAX"
                            : "PHARMACY"
                        } INVOICE`} */}
                  </div>
                </div>
                <div className="w30Per flex1-end">
                  <div className="flex-column">
                    {/* <div className="font-bold fs12 blue-color">
                      Business Name:
                    </div> */}
                    <div className="font-bold blue-color fs16">
                      {(selectedBill?.type === "Pharmacy"
                        ? (clinicDet?.pharmacyName ?? "")
                        : selectedBill?.type === "Pet Shop"
                          ? (clinicDet?.petShopName ?? "")
                          : (clinicDet?.pharmacyName ?? "")) ??
                        clinicDet?.name ??
                        ""}
                    </div>
                    {/* <div className="font-bold fs12 blue-color">
                      Business Address:
                    </div> */}
                    <div className="header-right-text2">
                      {(selectedBill?.type === "Pharmacy"
                        ? (clinicDet?.pharmacyAddress ?? "")
                        : selectedBill?.type === "Pet Shop"
                          ? (clinicDet?.petShopAddress ?? "")
                          : (clinicDet?.pharmacyAddress ?? "")) ??
                        clinicDet?.address ??
                        ""}
                    </div>
                    {clinicDet?.pharmacyTaxId?.length > 0 ||
                    clinicDet?.taxId?.length > 0 ||
                    clinicDet?.petShopTaxId?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          {/* {selectedBill?.type === "Pharmacy"
                            ? "PHARMACY"
                            : selectedBill?.type === "Pet Shop"
                              ? "PET SHOP"
                              : "PHARMACY"}{" "} */}
                          TAX ID:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {(selectedBill?.type === "Pet Shop"
                            ? clinicDet?.petShopTaxId
                            : clinicDet?.pharmacyTaxId) ??
                            clinicDet?.taxId ??
                            ""}{" "}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="line" />
              <div className="flex-row mt10 ph30">
                <div className="w60Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-bold fs14 gray4">
                      Parent Name
                    </Typography>
                    <div className="txt-semi-bold fs14 black capitalize ml10">
                      {selectedBill?.userName}
                    </div>
                  </div>
                  {selectedBill?.mobile?.length > 0 ? (
                    <div className="flex-row-ali-cen">
                      <Typography className="font-bold fs14 gray4">
                        Phone Number
                      </Typography>
                      <div className="txt-semi-bold fs14 black capitalize ml10">
                        {selectedBill?.mobile}
                      </div>
                    </div>
                  ) : null}
                  {selectedBill?.apartmentAddress?.length > 0 ? (
                    <div className="flex-row">
                      <Typography className="font-bold fs14 gray4">
                        Address
                      </Typography>

                      <div className="txt-semi-bold fs14 black capitalize ml10 w50Per flex-row-wrap">
                        {selectedBill?.apartmentAddress}
                      </div>
                    </div>
                  ) : null}
                </div>
                {(
                  selectedBill?.type === "Pharmacy" ||
                  selectedBill?.type === "Pet Shop"
                    ? selectedBill?.checkOut === "P"
                    : selectedBill?.pharmacyCheckout === "Y"
                ) ? (
                  <div className="flex1-end w40Per">
                    <div className="flex-column">
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Payment Status
                        </Typography>
                        <Typography
                          className={`ml10 fs16 font-bold capitalize ${
                            selectedBill?.pharmacyStatus === "paid"
                              ? "green2"
                              : selectedBill?.pharmacyStatus === "unpaid"
                                ? "red2"
                                : "orange-color"
                          }`}
                        >
                          {selectedBill?.pharmacyStatus === "partiallypaid"
                            ? "Partially Paid"
                            : selectedBill?.pharmacyStatus}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Total
                        </Typography>
                        <Typography className="black fs16 font-bold ml10">
                          Rs{" "}
                          {Number(
                            roundWithSignedDiff(
                              getTaxAndSubTotalAndTotal(
                                getPharmacyRecordBasedType(
                                  selectedBill?.paymentDetails,
                                ),
                              )?.subTotal,
                            )?.rounded,
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Amount Paid
                        </Typography>
                        <Typography className="green-color fs16 font-bold ml10">
                          Rs{" "}
                          {Number(selectedBill?.pharmacyAmtPaid) > 0
                            ? Number(selectedBill?.pharmacyAmtPaid)?.toFixed(2)
                            : Number(selectedBill?.pharmacyAmtPaid)}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Balance Due
                        </Typography>
                        <Typography className="yellow-color fs16 font-bold ml10">
                          Rs{" "}
                          {Number(
                            Number(
                              roundWithSignedDiff(
                                getTaxAndSubTotalAndTotal(
                                  getPharmacyRecordBasedType(
                                    selectedBill?.paymentDetails,
                                  ),
                                )?.subTotal,
                              )?.rounded,
                            ) - Number(selectedBill?.pharmacyAmtPaid ?? 0),
                          )?.toFixed(2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="lower-container">
                <div className="box-container">
                  <div className="row-container">
                    <div>
                      <div className="colum-header">Pet Name</div>
                      <div className="colum-data">{selectedBill?.petName}</div>
                    </div>
                    <div>
                      <div className="colum-header">Vet Name</div>
                      <div className="colum-data capitalize">
                        {getRightSaluation(clinicVets, selectedBill?.doctorId)}
                        {/* {selectedBill?.doctorId === selectedBill?.clinicId
                                ? ""
                                : "Dr. "} */}
                        {selectedBill?.doctorName}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Number</div>
                      <div className="colum-data">
                        {selectedBill?.invoiceNumbers ?? ""}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Date</div>
                      <div className="colum-data">
                        {moment(new Date(selectedBill?.createdDate)).format(
                          "DD MMM YYYY",
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="thin-line"></div>

                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th className="w10Per">HSN/SAC Code</th>
                        <th className="w25Per">SERVICE / ITEM NAME</th>
                        <th className="w10Per">BATCH NO.</th>
                        <th className="w10Per">EXPIRY</th>
                        <th className="w10Per">QTY</th>
                        <th className="w10Per">UNIT PRICE</th>
                        {getPharmacyRecordBasedType(
                          selectedBill?.paymentDetails,
                        )?.some((li) => li?.discount > 0) ? (
                          <th className="w10Per">UNIT DISCOUNT (Rs)</th>
                        ) : null}
                        <th className="w10Per">TAX</th>
                        <th className="w10Per">TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getPharmacyRecordBasedType(selectedBill?.paymentDetails)
                        ?.length > 0 &&
                        getPharmacyRecordBasedType(selectedBill?.paymentDetails)
                          ?.filter((pd) => pd?.type !== "consultation")
                          ?.map((itm, i) => {
                            return (
                              <tr key={`${itm?.paymentDetailId}_${i}`}>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.hsnSacCode?.length > 0
                                      ? itm?.hsnSacCode
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.name}
                                    {itm?.stockId ? (
                                      <div>
                                        <div className="font-medium fs10 gray4">
                                          Trade Name: {itm?.tradeName ?? ""}
                                        </div>
                                        {itm?.drugSchedule?.length > 0 ? (
                                          <div className="fs10 gray4 font-medium">
                                            Drug Schedule:{" "}
                                            {itm?.drugSchedule ?? ""}
                                          </div>
                                        ) : null}
                                      </div>
                                    ) : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.stockId &&
                                    !itm?.autoConsumed &&
                                    itm?.batchNo?.length > 0
                                      ? itm?.batchNo
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.stockId &&
                                    !itm?.autoConsumed &&
                                    itm?.expiryDate?.length > 0
                                      ? moment(
                                          new Date(itm?.expiryDate),
                                        ).format("DD MMM YYYY")
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.quantity}
                                    {itm?.stockId && itm?.packageUom?.length > 0
                                      ? `${getRightPackageUom(itm?.packageUom, true)}`
                                      : ""}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    Rs{" "}
                                    {Number(
                                      itm?.mrpPrice ?? itm?.price,
                                    )?.toFixed(2)}
                                  </div>
                                </td>
                                {getPharmacyRecordBasedType(
                                  selectedBill?.paymentDetails,
                                )?.some((li) => li?.discount > 0) ? (
                                  <td>
                                    <div className="fs12 font-bold black">
                                      {Number(
                                        itm?.mrpDiscount ?? itm?.discount,
                                      ) > 0
                                        ? Number(
                                            itm?.mrpDiscount ?? itm?.discount,
                                          )?.toFixed(2)
                                        : "-"}
                                    </div>
                                  </td>
                                ) : null}
                                <td>
                                  <div className="fs12 font-bold black">
                                    {clinicDet?.pharmacyTaxId?.length > 0
                                      ? itm?.tax > 0
                                        ? `Rs ${Number(itm?.tax)?.toFixed(2)}`
                                        : "-"
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    Rs {Number(itm?.total)?.toFixed(2)}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      <tr>
                        <td colSpan="12">
                          <hr className="thin-line2" />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="12">
                          <div className="flex-row-between">
                            <div className="w55Per ali-itm-flx-end">
                              <div className="flex-column w100Per">
                                <div className="flex-row-ali-cen mb5">
                                  <div className="txt-semi-bold fs12 black">
                                    Billed by:
                                  </div>
                                  <Typography className="font-bold fs12 gray4 ml10">
                                    {selectedBill?.pharmacyBilledByName ?? ""}
                                  </Typography>
                                </div>
                                {clinicDet?.disclaimer?.length > 0 ? (
                                  <div className="flex-row-ali-cen mb5">
                                    <div className="txt-semi-bold fs12 black">
                                      Disclaimer:
                                    </div>
                                    <Typography className="fs12 txt-regular gray-color ml10">
                                      {clinicDet?.disclaimer}
                                    </Typography>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div className="w45Per flex-end pr10">
                              <div className="flex-column w100Per">
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">
                                      {selectedBill?.type === "Pharmacy" ||
                                      selectedBill?.type === "Pet Shop"
                                        ? ""
                                        : "Pharmacy "}
                                      Subtotal
                                    </div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      Rs{" "}
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            selectedBill?.paymentDetails,
                                          ),
                                        )?.total,
                                      )?.toFixed(2)}
                                    </div>
                                  </div>
                                </div>
                                {Number(
                                  getTaxAndSubTotalAndTotal(
                                    getPharmacyRecordBasedType(
                                      selectedBill?.paymentDetails,
                                    ),
                                  )?.discount,
                                ) > 0 ? (
                                  <div className="flex-row-ali-cen mb5">
                                    <div className="w70Per">
                                      <div className="txtstyle">Discount</div>
                                    </div>
                                    <div className="w30Per flex-end">
                                      <div className="txtstyle">
                                        {Number(
                                          getTaxAndSubTotalAndTotal(
                                            getPharmacyRecordBasedType(
                                              selectedBill?.paymentDetails,
                                            ),
                                          )?.discount,
                                        ) > 0
                                          ? `Rs ${Number(
                                              getTaxAndSubTotalAndTotal(
                                                getPharmacyRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.discount,
                                            ).toFixed(2)}`
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Taxes (CGST)</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            selectedBill?.paymentDetails,
                                          ),
                                        )?.tax,
                                      ) /
                                        2 >
                                      0
                                        ? `Rs ${Number(
                                            Number(
                                              getTaxAndSubTotalAndTotal(
                                                getPharmacyRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.tax,
                                            ) / 2,
                                          )?.toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Taxes (SGST)</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      {Number(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            selectedBill?.paymentDetails,
                                          ),
                                        )?.tax,
                                      ) /
                                        2 >
                                      0
                                        ? `Rs ${Number(
                                            Number(
                                              getTaxAndSubTotalAndTotal(
                                                getPharmacyRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.tax,
                                            ) / 2,
                                          )?.toFixed(2)}`
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row-ali-cen mv5">
                                  <div className="w60Per">
                                    <div className="txtstyle">Round Off</div>
                                  </div>
                                  <div className="w40Per flex-end">
                                    <div className="txtstyle">
                                      {`Rs ${Number(
                                        Number(
                                          roundWithSignedDiff(
                                            getTaxAndSubTotalAndTotal(
                                              getPharmacyRecordBasedType(
                                                selectedBill?.paymentDetails,
                                              ),
                                            )?.subTotal,
                                          )?.difference,
                                        ),
                                      )?.toFixed(2)}`}
                                    </div>
                                  </div>
                                </div>
                                <div className="balancecontainer ph5 mt10">
                                  <div className="flex-row-ali-cen w100Per">
                                    <div className="w60Per">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        Total
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txt-semi-bold fs14 blue-color">
                                        Rs{" "}
                                        {Number(
                                          roundWithSignedDiff(
                                            getTaxAndSubTotalAndTotal(
                                              getPharmacyRecordBasedType(
                                                selectedBill?.paymentDetails,
                                              ),
                                            )?.subTotal,
                                          )?.rounded,
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <div className="mb20" />
                    </tbody>
                  </table>
                  {isDotMatrixPrint ? null : (
                    <div className="flex-row mv20 ph10">
                      <img
                        src={require("../../../assets/images/jpg/WoofQrCode.jpeg")}
                        alt=""
                        className="img-h50"
                      />
                      <div className="blu-back wh50 flex-center">
                        <img
                          src={require("../../../assets/images/png/VetInstantLogo.png")}
                          alt=""
                          className="img-h40"
                        />
                      </div>
                      <div className="flex-center">
                        <div className="font-bold fs14 ml20">
                          Scan to download our app
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          {billsToShow?.includes("petshop") &&
          getPetShopRecordBasedType(selectedBill?.paymentDetails)?.length >
            0 ? (
            <>
              <div className="mt30">
                <div className="flex-row-ali-cen mv20">
                  <div className="w30Per">
                    {isDotMatrixPrint ? null : (
                      <div className="pl20">
                        <div>
                          {clinicDet?.image ? (
                            <img
                              src={clinicDet?.image}
                              className="img-h75"
                              alt=""
                            />
                          ) : (
                            <div className="flex-center h50img">
                              <Typography className="font-bold fs30 white-color capitalize">
                                {clinicDet?.name?.[0]}
                              </Typography>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="w40Per flex-center">
                    <div className="font-bold fs18 blue-color">
                      {isBillCombined
                        ? "TAX INVOICE"
                        : (selectedBill?.type === "Clinic" &&
                              !selectedBill?.appointmentId) ||
                            ((selectedBill?.type === "Pharmacy" ||
                              selectedBill?.type === "Pet Shop") &&
                              selectedBill?.checkOut !== "P" &&
                              selectedBill?.checkOut !== "Y" &&
                              selectedBill?.petShopCheckout !== "Y")
                          ? "BILL ESTIMATE"
                          : "TAX INVOICE"}
                      {/* {selectedBill?.type === "Pharmacy" ||
                      selectedBill?.type === "Pet Shop"
                        ? selectedBill?.checkOut === "P" ||
                          selectedBill?.checkOut === "Y" ||
                          selectedBill?.petShopCheckout === "Y"
                          ? "TAX INVOICE"
                          : "BILL ESTIMATE"
                        : "TAX INVOICE"} */}
                    </div>
                  </div>
                  <div className="w30Per flex1-end">
                    <div className="flex-column">
                      {/* <div className="font-bold fs12 blue-color">
                        Business Name:
                      </div> */}
                      <div className="font-bold blue-color fs16">
                        {clinicDet?.petShopName ??
                          profile?.petShopName ??
                          clinicDet?.name ??
                          ""}
                      </div>
                      {/* <div className="font-bold fs12 blue-color">
                        Business Address:
                      </div> */}
                      <div className="header-right-text2">
                        {clinicDet?.petShopAddress ?? clinicDet?.address ?? ""}
                      </div>
                      {clinicDet?.petShopTaxId?.length > 0 ||
                      clinicDet?.taxId?.length > 0 ? (
                        <div className="flex-row-ali-cen">
                          <div className="font-bold fs12 blue-color">
                            {/* PET SHOP  */}
                            TAX ID:
                          </div>
                          <div className="header-right-text2 ml3">
                            {clinicDet?.petShopTaxId ?? clinicDet?.taxId ?? ""}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {clinicDet?.mobile?.length > 0 ? (
                        <div className="flex-row-ali-cen">
                          <div className="font-bold fs12 blue-color">
                            Contact:{" "}
                          </div>
                          <div className="header-right-text2 ml3">
                            {clinicDet?.mobile ?? ""}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="line" />
                <div className="flex-row mt10 ph30">
                  <div className="w60Per">
                    <div className="flex-row-ali-cen">
                      <Typography className="font-bold fs14 gray4">
                        Parent Name
                      </Typography>
                      <div className="txt-semi-bold fs14 black capitalize ml10">
                        {selectedBill?.userName}
                      </div>
                    </div>
                    {selectedBill?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 gray4">
                          Phone Number
                        </Typography>
                        <div className="txt-semi-bold fs14 black capitalize ml10">
                          {selectedBill?.mobile}
                        </div>
                      </div>
                    ) : null}
                    {selectedBill?.apartmentAddress?.length > 0 ? (
                      <div className="flex-row">
                        <Typography className="font-bold fs14 gray4">
                          Address
                        </Typography>

                        <div className="txt-semi-bold fs14 black capitalize ml10 w50Per flex-row-wrap">
                          {selectedBill?.apartmentAddress}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {(
                    selectedBill?.type === "Pharmacy" ||
                    selectedBill?.type === "Pet Shop"
                      ? selectedBill?.checkOut === "P"
                      : selectedBill?.petShopCheckout === "Y"
                  ) ? (
                    <div className="flex1-end w40Per">
                      <div className="flex-column">
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 gray4">
                            Payment Status
                          </Typography>
                          <Typography
                            className={`ml10 fs16 font-bold capitalize ${
                              selectedBill?.petShopStatus === "paid"
                                ? "green2"
                                : selectedBill?.petShopStatus === "unpaid"
                                  ? "red2"
                                  : "orange-color"
                            }`}
                          >
                            {selectedBill?.petShopStatus === "partiallypaid"
                              ? "Partially Paid"
                              : selectedBill?.petShopStatus}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 gray4">
                            Total
                          </Typography>
                          <Typography className="black fs16 font-bold ml10">
                            Rs{" "}
                            {Number(
                              roundWithSignedDiff(
                                getTaxAndSubTotalAndTotal(
                                  getPetShopRecordBasedType(
                                    selectedBill?.paymentDetails,
                                  ),
                                )?.subTotal,
                              )?.rounded,
                            )?.toFixed(2)}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 gray4">
                            Amount Paid
                          </Typography>
                          <Typography className="green-color fs16 font-bold ml10">
                            Rs{" "}
                            {Number(selectedBill?.petShopAmtPaid) > 0
                              ? Number(selectedBill?.petShopAmtPaid)?.toFixed(2)
                              : Number(selectedBill?.petShopAmtPaid)}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 gray4">
                            Balance Due
                          </Typography>
                          <Typography className="yellow-color fs16 font-bold ml10">
                            Rs{" "}
                            {Number(
                              Number(
                                roundWithSignedDiff(
                                  getTaxAndSubTotalAndTotal(
                                    getPetShopRecordBasedType(
                                      selectedBill?.paymentDetails,
                                    ),
                                  )?.subTotal,
                                )?.rounded,
                              ) - Number(selectedBill?.petShopAmtPaid ?? 0),
                            )?.toFixed(2)}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="lower-container">
                  <div className="box-container">
                    <div className="row-container">
                      <div>
                        <div className="colum-header">Pet Name</div>
                        <div className="colum-data">
                          {selectedBill?.petName}
                        </div>
                      </div>
                      <div>
                        <div className="colum-header">Parent Name</div>
                        <div className="colum-data capitalize">
                          {selectedBill?.userName}
                        </div>
                      </div>
                      <div>
                        <div className="colum-header">Invoice Number</div>
                        <div className="colum-data">
                          {selectedBill?.petShopInvoiceNumber ?? ""}
                        </div>
                      </div>
                      <div>
                        <div className="colum-header">Invoice Date</div>
                        <div className="colum-data">
                          {moment(new Date()).format("DD MMM YYYY")}
                        </div>
                      </div>
                    </div>

                    <div className="thin-line" />

                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th className="w10Per">HSN/SAC Code</th>
                          <th className="w25Per">SERVICE / ITEM NAME</th>
                          <th className="w10Per">BATCH NO.</th>
                          <th className="w10Per">EXPIRY</th>
                          <th className="w10Per">QTY</th>
                          <th className="w10Per">UNIT PRICE</th>
                          {getPetShopRecordBasedType(
                            selectedBill?.paymentDetails,
                          )?.some((li) => li?.discount > 0) ? (
                            <th className="w10Per">UNIT DISCOUNT (Rs)</th>
                          ) : null}
                          <th className="w10Per">TAX</th>
                          <th className="w10Per">TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getPetShopRecordBasedType(selectedBill?.paymentDetails)
                          ?.filter((li) => li?.quantity > 0)
                          ?.map((itm, i) => {
                            return (
                              <tr key={`${itm?.paymentDetailId}_${i}`}>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.hsnSacCode?.length > 0
                                      ? itm?.hsnSacCode
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.name}
                                    {itm?.stockId ? (
                                      <div>
                                        <div className="font-medium fs10 gray4">
                                          Trade Name: {itm?.tradeName ?? ""}
                                        </div>
                                        {itm?.drugSchedule?.length > 0 ? (
                                          <div className="fs10 gray4 font-medium">
                                            Drug Schedule:{" "}
                                            {itm?.drugSchedule ?? ""}
                                          </div>
                                        ) : null}
                                      </div>
                                    ) : null}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.stockId &&
                                    !itm?.autoConsumed &&
                                    itm?.batchNo?.length > 0
                                      ? itm?.batchNo
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.stockId &&
                                    !itm?.autoConsumed &&
                                    itm?.expiryDate?.length > 0
                                      ? moment(
                                          new Date(itm?.expiryDate),
                                        ).format("DD MMM YYYY")
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    {itm?.quantity}
                                    {itm?.stockId && itm?.packageUom?.length > 0
                                      ? `${getRightPackageUom(itm?.packageUom, true)}`
                                      : ""}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    Rs{" "}
                                    {Number(
                                      itm?.mrpPrice ?? itm?.price,
                                    )?.toFixed(2)}
                                  </div>
                                </td>
                                {getPetShopRecordBasedType(
                                  selectedBill?.paymentDetails,
                                )?.some((li) => li?.discount > 0) ? (
                                  <td>
                                    <div className="fs12 font-bold black">
                                      {Number(
                                        itm?.mrpDiscount ?? itm?.discount,
                                      ) > 0
                                        ? Number(
                                            itm?.mrpDiscount ?? itm?.discount,
                                          )?.toFixed(2)
                                        : "-"}
                                    </div>
                                  </td>
                                ) : null}
                                <td>
                                  <div className="fs12 font-bold black">
                                    {clinicDet?.pharmacyTaxId?.length > 0
                                      ? itm?.tax > 0
                                        ? `Rs ${Number(itm?.tax)?.toFixed(2)}`
                                        : "-"
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div className="fs12 font-bold black">
                                    Rs {Number(itm?.total)?.toFixed(2)}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        <tr>
                          <td colSpan="12">
                            <hr className="thin-line2" />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="12">
                            <div className="flex-row-between">
                              <div className="w55Per ali-itm-flx-end">
                                <div className="flex-column w100Per">
                                  <div className="flex-row-ali-cen mb5">
                                    <div className="txt-semi-bold fs12 black">
                                      Billed by:
                                    </div>
                                    <Typography className="font-bold fs12 gray4 ml10">
                                      {selectedBill?.petShopBilledByName ?? ""}
                                    </Typography>
                                  </div>
                                  {clinicDet?.disclaimer?.length > 0 ? (
                                    <div className="flex-row-ali-cen mb5">
                                      <div className="txt-semi-bold fs12 black">
                                        Disclaimer:
                                      </div>
                                      <Typography className="fs12 txt-regular gray-color ml10">
                                        {clinicDet?.disclaimer}
                                      </Typography>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="w45Per flex-end pr10">
                                <div className="flex-column w100Per">
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="txtstyle">Subtotal</div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txtstyle">
                                        Rs{" "}
                                        {Number(
                                          Number(
                                            getTaxAndSubTotalAndTotal(
                                              getPetShopRecordBasedType(
                                                selectedBill?.paymentDetails,
                                              ),
                                            )?.total ?? 0,
                                          ),
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  {Number(
                                    getTaxAndSubTotalAndTotal(
                                      getPetShopRecordBasedType(
                                        selectedBill?.paymentDetails,
                                      ),
                                    )?.discount,
                                  ) > 0 ? (
                                    <div className="flex-row-ali-cen mb5">
                                      <div className="w70Per">
                                        <div className="txtstyle">Discount</div>
                                      </div>
                                      <div className="w30Per flex-end">
                                        <div className="txtstyle">
                                          {Number(
                                            getTaxAndSubTotalAndTotal(
                                              getPetShopRecordBasedType(
                                                selectedBill?.paymentDetails,
                                              ),
                                            )?.discount,
                                          ) > 0
                                            ? `Rs. ${Number(
                                                getTaxAndSubTotalAndTotal(
                                                  getPetShopRecordBasedType(
                                                    selectedBill?.paymentDetails,
                                                  ),
                                                )?.discount,
                                              ).toFixed(2)}`
                                            : "-"}
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="txtstyle">
                                        Taxes (CGST)
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txtstyle">
                                        Rs{" "}
                                        {clinicDet?.petShopTaxId?.length > 0
                                          ? Number(
                                              getTaxAndSubTotalAndTotal(
                                                getPetShopRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.tax / 2,
                                            ).toFixed(2)
                                          : Number(0)?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="txtstyle">
                                        Taxes (SGST)
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txtstyle">
                                        Rs{" "}
                                        {clinicDet?.petShopTaxId?.length > 0
                                          ? Number(
                                              getTaxAndSubTotalAndTotal(
                                                getPetShopRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.tax / 2,
                                            ).toFixed(2)
                                          : Number(0)?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="txtstyle">Round Off</div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="txtstyle">
                                        {`Rs ${Number(
                                          Number(
                                            roundWithSignedDiff(
                                              getTaxAndSubTotalAndTotal(
                                                getPetShopRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.subTotal,
                                            )?.difference,
                                          ),
                                        )?.toFixed(2)}`}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="balancecontainer ph5 mt10">
                                    <div className="flex-row-ali-cen w100Per">
                                      <div className="w60Per">
                                        <div className="txt-semi-bold fs14 blue-color">
                                          Total
                                        </div>
                                      </div>
                                      <div className="w40Per flex-end">
                                        <div className="txt-semi-bold fs14 blue-color">
                                          {`Rs. ${Number(
                                            roundWithSignedDiff(
                                              getTaxAndSubTotalAndTotal(
                                                getPetShopRecordBasedType(
                                                  selectedBill?.paymentDetails,
                                                ),
                                              )?.subTotal,
                                            )?.rounded,
                                          )?.toFixed(2)}`}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <div className="mb20" />
                      </tbody>
                    </table>
                    {isDotMatrixPrint ? null : (
                      <div className="flex-row mv20 ph10">
                        <img
                          src={require("../../../assets/images/jpg/WoofQrCode.jpeg")}
                          alt=""
                          className="img-h50"
                        />
                        <div className="blu-back wh50 flex-center">
                          <img
                            src={require("../../../assets/images/png/VetInstantLogo.png")}
                            alt=""
                            className="img-h40"
                          />
                        </div>
                        <div className="flex-center">
                          <div className="font-bold fs14 ml20">
                            Scan to download our app
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>

        {billsToShow?.length > 0 &&
        getTreatmentRecordBasedType(selectedBill?.paymentDetails)?.length +
          getPharmacyRecordBasedType(selectedBill?.paymentDetails)?.length +
          getPetShopRecordBasedType(selectedBill?.paymentDetails)?.length >
          0 ? null : (
          <div className="no-rec">No records available</div>
        )}

        {billsToShow?.length > 0 &&
        getTreatmentRecordBasedType(selectedBill?.paymentDetails)?.length +
          getPharmacyRecordBasedType(selectedBill?.paymentDetails)?.length +
          getPetShopRecordBasedType(selectedBill?.paymentDetails)?.length >
          0 ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="back-white"
          >
            <div className="flex-end mb20">
              <div className="flex-row-ali-cen">
                <div>
                  <CustomCheckbox
                    label="Dot Matrix (Monospace)"
                    checked={isDotMatrixPrint}
                    onChange={() => setDotMatrixPrint(!isDotMatrixPrint)}
                  />
                </div>
                <div className="mr20">
                  <CustomButton
                    text="Print"
                    onClick={() =>
                      handlePrint(null, () => contentToPrint.current)
                    }
                    smallBtn
                  />
                </div>
              </div>
            </div>
          </Grid>
        ) : null}
      </div>
    </CustomModal>
  );
};

export default BillingPreview;
